import { Box, Slider, Typography } from '@mui/material';
import { useState } from 'react';

export const CustomSlider = ({
  value,
  onChange,
  onChangeBeforeCommited,
  label,
  min = 0,
  max = 100,
  defaultValue,
  marks,
  width,
  disabled = false,
  labelPosition = 'top'
}: {
  value?: number[];
  onChange?: (value: number | number[]) => void;
  onChangeBeforeCommited?: (value: number | number[]) => void;
  label?: string;
  min?: number;
  max?: number;
  defaultValue?: number[];
  marks?: { value: number; label: string }[];
  width?: string | number;
  disabled?: boolean;
  labelPosition?: 'top' | 'bottom' | 'left' | 'right';
}) => {
  const [innerValue, setInnerValue] = useState<number[]>(value || defaultValue || []);
  const isRange =
    (Array.isArray(value) && value?.length > 1) || (Array.isArray(defaultValue) && defaultValue?.length > 1);

  const renderLabel = () => {
    if (!label) return null;

    const labelStyles = {
      top: { mb: 1 },
      bottom: { mt: 1 },
      left: { ml: 2, display: 'flex', alignItems: 'center', mb: 2.5 },
      right: { mr: 2, display: 'flex', alignItems: 'center', mb: 2.5 }
    };

    return (
      <Typography variant="body1" sx={{ ...labelStyles[labelPosition], whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    );
  };

  const renderSlider = () => (
    <Slider
      value={value || innerValue}
      onChange={(e, newValue) => {
        setInnerValue(newValue as number[]);
        onChangeBeforeCommited?.(newValue);
      }}
      onChangeCommitted={(e, newValue) => {
        onChange?.(newValue);
      }}
      aria-labelledby="discrete-slider"
      min={min}
      max={max}
      defaultValue={defaultValue ? defaultValue : isRange ? [min, max] : min}
      marks={
        marks
          ? marks
          : isRange
          ? [min, ...(value || innerValue), max].map((v, i) => ({
              value: v,
              label: `${v}`
            }))
          : [min, max].map((v, i) => ({
              value: v,
              label: `${v}`
            }))
      }
      disabled={disabled}
    />
  );

  if (labelPosition === 'left' || labelPosition === 'right') {
    return (
      <Box sx={{ width: width ?? '100%', display: 'flex', alignItems: 'center', gap: 2, mx: 2 }}>
        {labelPosition === 'left' && renderLabel()}
        {renderSlider()}
        {labelPosition === 'right' && renderLabel()}
      </Box>
    );
  }

  return (
    <Box sx={{ width: width ?? '100%', mx: 2 }}>
      {labelPosition === 'top' && renderLabel()}
      {renderSlider()}
      {labelPosition === 'bottom' && renderLabel()}
    </Box>
  );
};

export default CustomSlider;
